/**
 * Prestigio del Clan — Servicios (Mocks)
 * Nota: Estos mocks NO hacen llamadas HTTP. Devuelven datos estáticos para activar la UI.
 * Cuando el backend esté listo, reemplazar por HttpClient y endpoints reales.
 */

/**
 * @typedef {Object} PrestigeEntry
 * @property {number|string} characterId
 * @property {string} name
 * @property {number} points
 * @property {number} missions
 * @property {string} [tier] // Bronze|Silver|Gold|Elite
 * @property {string} [lastAt] // ISO
 */

/**
 * Mock: Overview público del clan
 * @param {string|number} clanIdOrSlug
 * @param {string} [seasonId='current']
 * @returns {Promise<{ seasonId:string, clanIdOrSlug:string|number, top5:PrestigeEntry[], totalParticipants:number, lastUpdateAt:string }>}
 */
export async function fetchClanPrestigeOverview(clanIdOrSlug, seasonId = 'current') {
  const now = new Date().toISOString();
  const top5 = [
    { characterId: 'c1', name: 'Akira', points: 180, missions: 6, tier: 'Gold', lastAt: now },
    { characterId: 'c2', name: 'Hana', points: 162, missions: 5, tier: 'Gold', lastAt: now },
    { characterId: 'c3', name: 'Daichi', points: 140, missions: 5, tier: 'Silver', lastAt: now },
    { characterId: 'c4', name: 'Riku', points: 120, missions: 4, tier: 'Silver', lastAt: now },
    { characterId: 'c5', name: 'Mika', points: 97, missions: 3, tier: 'Bronze', lastAt: now },
  ];
  return {
    seasonId,
    clanIdOrSlug,
    top5,
    totalParticipants: 17,
    lastUpdateAt: now,
  };
}

/**
 * Mock: Leaderboard por clan
 * @param {string|number} clanIdOrSlug
 * @param {string} [seasonId='current']
 * @returns {Promise<{ seasonId:string, clanIdOrSlug:string|number, entries:PrestigeEntry[], updatedAt:string }>}
 */
export async function fetchClanPrestigeLeaderboard(clanIdOrSlug, seasonId = 'current') {
  const overview = await fetchClanPrestigeOverview(clanIdOrSlug, seasonId);
  // Simular lista extendida (top5 + placeholders)
  const extra = Array.from({ length: 10 }).map((_, i) => ({
    characterId: `cx${i + 6}`,
    name: `Ninja ${i + 6}`,
    points: Math.max(10, 90 - i * 5),
    missions: 1 + (i % 3),
    lastAt: overview.lastUpdateAt,
  }));
  return {
    seasonId,
    clanIdOrSlug,
    entries: [...overview.top5, ...extra],
    updatedAt: overview.lastUpdateAt,
  };
}

/**
 * Mock: Puntuación del usuario actual en el clan
 * @param {string|number} clanIdOrSlug
 * @param {string} [seasonId='current']
 * @returns {Promise<{ seasonId:string, characterId:string|number, name:string, points:number, rank:number, missions:number, weeklyUsed:number, weeklyCap:number, nextResetAt:string }>}
 */
export async function fetchClanPrestigeMe(clanIdOrSlug, seasonId = 'current') {
  const nextMonday00UTC = (() => {
    const d = new Date();
    const day = d.getUTCDay(); // 0=Domingo
    const diff = (8 - day) % 7; // días hasta lunes
    d.setUTCDate(d.getUTCDate() + diff);
    d.setUTCHours(0, 0, 0, 0);
    return d.toISOString();
  })();
  return {
    seasonId,
    characterId: 'me',
    name: 'Tu personaje',
    points: 88,
    rank: 4,
    missions: 3,
    weeklyUsed: 60,
    weeklyCap: 200,
    nextResetAt: nextMonday00UTC,
  };
}